import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=fcd22620&scoped=true&"
import script from "./PercentageBar.vue?vue&type=script&lang=js&"
export * from "./PercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=fcd22620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd22620",
  null
  
)

export default component.exports